import t from "../../../utils/translate";

import {
  FIRST_NAME,
  LAST_NAME,
  EMAIL,
  PASSWORD,
  COUPON_CODE
} from "../constants";

const rules = window.ww.validations;

const isValidRegex = (value, regex) => {
  const pattern = new RegExp(regex);

  return pattern.test(value);
};

const fieldData = {
  [FIRST_NAME]: {
    name: FIRST_NAME,
    id: FIRST_NAME,
    placeholder: t("JS_LEGAL_FIRST_NAME"),
    rules: {
      errorMessages: {
        isRequired: t("FIELD_ERROR_REQUIRED"),
        isMoreThanMax: t("JS_FIRST_NAME_ERROR_TOO_LONG"),
        isInvalidPattern: t("JS_FIRST_NAME_ERROR_INVALID")
      },
      validators: {
        isRequired: value => String(value).length === 0,
        isMoreThanMax: value => rules.firstName.max < String(value).length,
        isInvalidPattern: value => !isValidRegex(value, rules.firstName.regex)
      }
    }
  },
  [LAST_NAME]: {
    name: LAST_NAME,
    id: LAST_NAME,
    placeholder: t("JS_LEGAL_LAST_NAME"),
    rules: {
      errorMessages: {
        isRequired: t("FIELD_ERROR_REQUIRED"),
        isMoreThanMax: t("JS_LAST_NAME_ERROR_TOO_LONG"),
        isInvalidPattern: t("JS_LAST_NAME_ERROR_INVALID")
      },
      validators: {
        isRequired: value => String(value).length === 0,
        isMoreThanMax: value => rules.lastName.max < String(value).length,
        isInvalidPattern: value => !isValidRegex(value, rules.lastName.regex)
      }
    }
  },
  [EMAIL]: {
    name: EMAIL,
    id: EMAIL,
    placeholder: t("EMAIL_PLACEHOLDER"),
    rules: {
      errorMessages: {
        isRequired: t("FIELD_ERROR_REQUIRED"),
        isMoreThanMax: t("EMAIL_ERROR_TOO_LONG"),
        isInvalidPattern: t("JS_EMAIL_ERROR_INVALID")
      },
      validators: {
        isRequired: value => String(value).length === 0,
        isMoreThanMax: value => rules.email.max < String(value).length,
        isInvalidPattern: value => !isValidRegex(value, rules.email.regex)
      }
    }
  },
  [PASSWORD]: {
    name: PASSWORD,
    id: PASSWORD,
    placeholder: t("JS_PASSWORD"),
    rules: {
      errorMessages: {
        isRequired: t("FIELD_ERROR_REQUIRED"),
        isLongAndClean: t("JS_LONG_AND_CLEAN_ERROR"),
        oneLetterOneNumber: t("JS_ONE_LETTER_ONE_NUMBER_ERROR")
      },
      validators: {
        isRequired: value => String(value).length === 0,
        isLongAndClean: value =>
          !isValidRegex(value, /^(?!.*[<> ])[^\s<>]{8,20}$/gi),
        oneLetterOneNumber: value =>
          !isValidRegex(value, /^(?=.*[a-zA-Z])(?=.*[0-9])/gi)
      }
    },
    type: PASSWORD,
    maxLength: rules.password.max
  },
  [COUPON_CODE]: {
    name: COUPON_CODE,
    id: COUPON_CODE,
    placeholder: t("COUPON_CODE_PLACEHOLDER"),
    rules: {
      errorMessages: {},
      validators: {}
    }
  }
};

export default fieldData;
